__turbopack_context__.v({
  "appHeader": "kalshi-math-module__RTCMeG__appHeader",
  "board": "kalshi-math-module__RTCMeG__board",
  "bookQuotes": "kalshi-math-module__RTCMeG__bookQuotes",
  "caption": "kalshi-math-module__RTCMeG__caption",
  "comparison": "kalshi-math-module__RTCMeG__comparison",
  "comparisonTitle": "kalshi-math-module__RTCMeG__comparisonTitle",
  "converter": "kalshi-math-module__RTCMeG__converter",
  "devigTable": "kalshi-math-module__RTCMeG__devigTable",
  "examples": "kalshi-math-module__RTCMeG__examples",
  "explainer": "kalshi-math-module__RTCMeG__explainer",
  "fairPanel": "kalshi-math-module__RTCMeG__fairPanel",
  "fairResult": "kalshi-math-module__RTCMeG__fairResult",
  "game": "kalshi-math-module__RTCMeG__game",
  "kalshiPrice": "kalshi-math-module__RTCMeG__kalshiPrice",
  "row": "kalshi-math-module__RTCMeG__row",
  "rowHeaders": "kalshi-math-module__RTCMeG__rowHeaders",
  "stat": "kalshi-math-module__RTCMeG__stat",
  "toolbar": "kalshi-math-module__RTCMeG__toolbar",
});
